import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-flag-gb",
  "use": "icon-flag-gb-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-flag-gb\"><defs><style type=\"text/css\"></style></defs><path d=\"M65.2 202.9H960v617.7H65.2z\" fill=\"#00237A\" p-id=\"3782\" /><path d=\"M960 419.8H599V202.9H423.5v216.9H65.2v184.1h358.3v216.7H599V603.9h361V419.8z m0 0\" fill=\"#FFFFFF\" p-id=\"3783\" /><path d=\"M960 750.2L165.6 202.9H65.2v71.2l793.7 546.5H960v-70.4z m0 0\" fill=\"#FFFFFF\" p-id=\"3784\" /><path d=\"M65.2 750.2L859.6 203H960v71.2L166.3 820.6H65.2v-70.4z m0 0\" fill=\"#FFFFFF\" p-id=\"3785\" /><path d=\"M960 458.5H562.1V202.9H460.3v255.5H65.2v106.8h395.1v255.4h101.8V565.3H960V458.5z m0 0\" fill=\"#CF142B\" p-id=\"3786\" /><path d=\"M960 820.6v-48.5L713.8 603.9h-69.3L960 820.6z m0-617.7h-69.3L599 401.6v18.2h43.3L960 202.9z m-582 401L65.2 819.1v1.5h66.4l291.8-200v-16.7H378z m-312.8-401v48.5l244.9 168.4h70L65.2 202.9z m0 0\" fill=\"#CF142B\" p-id=\"3787\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/flag-gb.svg
// module id = hcyc
// module chunks = 24